export default {
    common: {
        saved: 'Saved.',
        savedWeight: 'Saved: {weight}.',
        saveFailed: "Couldn't save. Please try again.",
        deleteFailed: "Couldn't delete.",
        saving: 'Saving…',
        save: 'Save',
        add: 'Add',
        remove: 'Delete',
        days: '{n} days',
        weekDays: 'Days of the week',
        chartRange: 'Chart range',
        showOlder: 'Show older',
        workout: 'Workout',
        measurement: 'Weigh-in',
        weighIn: 'Weigh yourself',
        workoutUnit: 'workout | workouts',
        markDoneAria: '{name}: mark as done',
        doneTitle: 'Done',
        doneFlash: '{name} — done!',
        markFailed: "Couldn't tick off the workout.",
        perWeek: '{weight} / week',
    },
    quality: {
        l1: 'Awful',
        l2: 'Poor',
        l3: 'So-so',
        l4: 'Good',
        l5: 'Great',
    },
    suggestions: {
        running: 'Running',
        gym: 'Gym',
        cycling: 'Cycling',
        walking: 'Walking',
        yoga: 'Yoga',
        swimming: 'Swimming',
    },
    now: {
        title: 'Now',
        highlightNight: {
            title: 'First night',
            text: 'In the evening tap “Going to bed”, and in the morning the wake-up button. You can add a forgotten night on the Sleep tab.',
        },
        highlightQuality: {
            title: 'Rate your night',
            text: 'After you wake up, a rating appears in this card — one tap. You can rate older nights on the Sleep tab.',
        },
        wakeMale: "I'm up",
        wakeFemale: "I'm up",
        wakeNeutral: 'Wake up',
        versusSame: 'same as your 7-day average',
        versusDiff: '{diff} vs your 7-day average',
        bedFlash: 'Good night. Fell asleep: {time}.',
        wakeFlash: 'Good morning! How did you sleep?',
        ratedFlash: 'Saved: {quality}.',
        nightOngoing: 'NIGHT IN PROGRESS',
        tonight: 'LAST NIGHT',
        lastNight: 'LATEST NIGHT',
        sleep: 'SLEEP',
        sleepLink: 'Sleep',
        sinceBedtime: 'since falling asleep at {time}',
        wokeAt: 'woke up {time}',
        addBedtime: 'add bedtime',
        howSleptQuestion: 'How did you sleep?',
        howSlept: 'How you slept',
        qualityLine: 'Quality: {quality}',
        noNightsTitle: 'No nights yet',
        noNightsText: 'In the evening tap “Going to bed”, and in the morning the wake-up button — we’ll work out the rest.',
        goToBed: 'Going to bed',
        fixTime: 'Fix the time',
        addNight: 'Add a night manually',
        activityTitle: 'ACTIVITY · THIS WEEK',
        activityLink: 'Activity',
        weekTotal: '{duration} in total',
        weekEmpty: 'nothing yet this week',
        dotDone: 'workout done',
        dotPlanned: 'workout planned',
        dotNone: 'no workout',
        weightTitle: 'WEIGHT',
        weightLink: 'Weight',
        today: 'today',
        toTarget: 'To goal {weight}',
        reached: 'reached',
        sparkAria: '30-day weight trend',
        weighEmpty: 'Weigh yourself — your chart and trend start with the first weigh-in. Ideally in the morning, at a similar time.',
    },
    sleep: {
        title: 'Sleep',
        action: 'Night',
        subtitle: 'average {duration} over {days} days',
        lengthTitle: 'NIGHT LENGTH',
        regularityTitle: 'REGULARITY · {days} DAYS',
        fallAsleep: 'You usually fall asleep',
        wakeUp: 'You usually get up',
        regularityEmpty: "We'll work this out once you have full nights (with bedtime and wake-up) from the last {days} days.",
        nightsTitle: 'NIGHTS',
        noWake: 'no wake-up',
        noBedtime: 'no bedtime',
        nap: 'nap {range} · {length}',
        qualityAria: 'Quality: {quality}',
        empty: 'No nights yet. On the {now} screen you can log one with a single tap.',
        emptyLink: 'Now',
    },
    activity: {
        title: 'Activity',
        subtitle: '{n} workout in 30 days | {n} workouts in 30 days',
        thisWeek: 'This week',
        lastWeek: 'Last week',
        thisWeekTitle: 'THIS WEEK',
        dayDone: '{n} done',
        dayPlanned: 'planned',
        dayNone: 'no workout',
        minutes: 'min',
        addTitle: 'ADD',
        plan: 'Plan',
        types: 'Workout types ({n})',
        plannedTitle: 'PLANNED',
        notTickedTitle: 'Not ticked off — done?',
        notTicked: 'not ticked off',
        empty: 'No workouts yet. Add your first one or plan it for tomorrow.',
        statsTitle: 'LAST 30 DAYS',
        distanceTotal: '{distance} in total',
        statsEmpty: 'Appears after your first completed workout.',
    },
    weight: {
        title: 'Weight',
        year: 'Year',
        all: 'All',
        etaWeek: 'at this pace — in a week',
        etaLong: 'at this pace — in over 2 years',
        etaDate: 'at this pace — around {date}',
        deletedFlash: 'Weigh-in deleted.',
        targetRemovedFlash: 'Target weight removed.',
        targetFlash: 'Goal: {weight}.',
        trendTitle: 'TREND',
        noMeasurements: 'No weigh-ins',
        firstStartsChart: 'Your first weigh-in starts the chart.',
        targetTitle: 'TARGET WEIGHT',
        change: 'Change',
        reached: 'Reached — keep it up.',
        left: 'To go',
        pace: 'Pace (4 wks)',
        wrongWay: 'The trend is currently moving away from your goal.',
        paceLater: "We'll work out your pace after a few weigh-ins over a week.",
        targetEmpty: "No deadline, no pressure — you'll see how much is left and how fast you're going.",
        setTarget: 'Set target weight',
        change30: '30-day trend change',
        measurementsTitle: 'WEIGH-INS',
    },
    kgInput: {
        less: '0.1 kg less',
        more: '0.1 kg more',
    },
    qualityPicker: {
        label: 'How did you sleep?',
    },
    sheet: {
        close: 'Close',
    },
    sleepChart: {
        noNight: 'no night',
        unfinished: 'night not finished',
        average: 'average {duration}',
    },
    startWizard: {
        weightError: 'Enter a weight between 20 and 400 kg, e.g. {example} — or skip.',
        targetError: 'Enter a weight between 20 and 400 kg — or skip.',
        typesError: 'Pick at least one type — or skip.',
        saveFailed: "Couldn't save. Try again or skip.",
        weight: {
            title: 'How much do you weigh today?',
            text: 'Your first weigh-in — the chart starts from it. Ideally in the morning, before breakfast.',
        },
        target: {
            title: 'Do you have a target weight?',
            text: "No deadline, no pressure. We'll show you how much is left and how fast you're going.",
        },
        types: {
            title: 'How do you keep active?',
            text: "Pick your workout types — you'll choose one for each workout. You can change them later on the Activity tab.",
        },
        progress: 'FITNESS SETUP · {current} OF {total}',
        skipGuide: 'Skip the guide',
        weightLabel: 'Weight',
        targetLabel: 'Target weight',
        current: 'Currently: {weight}',
        ownLabel: 'Your own type',
        ownPlaceholder: 'Something else? e.g. Tennis',
        skipStep: 'Skip this step',
        finish: 'Done — show Fitness',
        next: 'Next',
    },
    targetDialog: {
        title: 'Target weight',
        subtitle: "No deadline — we'll work out your pace from your weigh-ins.",
        label: 'I want to weigh',
        error: 'Enter a weight between 20 and 400 kg, e.g. 75.',
        remove: 'Remove target weight',
    },
    typesSheet: {
        title: 'Workout types',
        subtitle: 'Each workout has one type — it sets the colour.',
        exists: '“{name}” is already on the list.',
        addFailed: "Couldn't add the type.",
        renameFailed: "Couldn't rename it.",
        inUse: '“{name}” has saved workouts, so it stays. Rename it if you need to.',
        newNameAria: 'New name: {name}',
        renameAria: 'Rename: {name}',
        deleteAria: 'Delete: {name}',
        empty: "You don't have any types yet — add your first one.",
        newLabel: 'New type',
        placeholder: 'e.g. Swimming',
    },
    weightChart: {
        aria: 'Weight: {n} weigh-ins in the selected period',
        target: 'goal {weight}',
        tooltip: '{weight} · trend {trend}',
        empty: 'No weigh-ins in this period.',
        legendPoint: 'weigh-in',
        legendTrend: 'trend (7-day average)',
        offScale: 'off the scale',
    },
    weightDialog: {
        today: 'Today',
        yesterday: 'Yesterday',
        error: 'Enter a weight between 20 and 400 kg, e.g. {example}.',
        dayError: 'Pick a day — today or earlier.',
        editTitle: 'Edit weigh-in',
        newTitle: 'New weigh-in',
        subtitle: 'Last time {weight} · {date}',
        weightLabel: 'Weight',
        emptyHint: 'Leave it empty to save {weight} — same as last time.',
        dayLabel: 'Day',
        replaces: 'There is already a weigh-in of {weight} on this day — it will be replaced.',
        confirmTitle: 'Delete weigh-in?',
    },
    firstSteps: {
        night: {
            title: 'First night',
            action: 'Show me how',
            what: 'In the evening tap “Going to bed”, in the morning the wake-up button — the times save themselves.',
            why: 'Over the nights you’ll see how long you sleep on average and how regular your bedtime is. You can add a forgotten night on the Sleep tab.',
        },
        quality: {
            title: 'Rate your night',
            action: 'Show me how',
            what: 'After waking up, one tap: how did you sleep.',
            why: 'A rating next to your sleep length shows how much sleep really works for you.',
        },
        weight: {
            title: 'First weigh-in',
            action: 'Add weigh-in',
            what: 'Today’s weight — ideally in the morning, before breakfast.',
            why: 'We calculate a 7-day average from your weigh-ins, so day-to-day swings don’t hide the direction.',
        },
        target: {
            title: 'Target weight',
            action: 'Set a goal',
            what: 'The weight you’re aiming for — no deadline.',
            why: 'You’ll see how much is left, how fast you’re going and when you’ll reach your goal at this pace.',
        },
        types: {
            title: 'Workout types',
            action: 'Pick types',
            what: 'Running, gym, walking — whatever you do most often.',
            why: 'You log a workout with one choice, and your 30-day stats are split by type.',
        },
        workout: {
            title: 'First workout',
            action: 'Add workout',
            what: 'Type and duration; distance and calories if you like.',
            why: 'You see your week dot by dot and how active you’ve been over the last 30 days.',
        },
        plan: {
            title: 'Plan a workout',
            action: 'Plan',
            what: 'A workout on a specific day ahead of you.',
            why: 'On that day you’ll see it on the Fitness home screen and tick it off with the circle when you’re done.',
        },
    },
    help: {
        night: {
            title: 'Latest night',
            text: 'In the evening tap “Going to bed”, in the morning the wake-up button — the times save themselves. After waking up you rate the night with one tap.',
            more: 'A night belongs to the day you wake up. The comparison shows whether it was longer or shorter than your average over the last 7 days.',
        },
        activity: {
            title: 'Activity this week',
            text: 'How many workouts and how much time. Tick off a workout planned for today with the circle once you’ve done it.',
        },
        weight: {
            title: 'Weight',
            text: 'Latest weigh-in, 30-day change and trend. “Weigh-in” suggests your last weight — you just adjust it by a few tenths.',
        },
        sleepChart: {
            title: 'Sleep: night length',
            text: 'The last 7 or 30 nights and the average. Tap a bar to see the times.',
        },
        sleepRegularity: {
            title: 'Regularity',
            text: 'Your average bedtime and wake-up time. The smaller the spread, the steadier your rhythm.',
            more: 'Only full nights count — with both bedtime and wake-up.',
        },
        sleepList: {
            title: 'All nights',
            text: 'Tap a night to fix it or add a nap. A night belongs to the day you wake up.',
        },
        activityWeek: {
            title: 'Your week',
            text: 'Filled dot — workout done, outline — planned.',
            more: 'The dot shows how many minutes of workouts you did that day.',
        },
        activityActions: {
            title: 'Add or plan',
            text: '“Workout” logs what you’ve already done, “Plan” — what’s ahead of you. This is also where you edit workout types.',
        },
        activityPlanned: {
            title: 'Planned',
            text: 'Workouts ahead of you. The circle marks a workout as done — tap the name to change the day or details.',
        },
        activityHistory: {
            title: 'History',
            text: 'Completed workouts week by week, with total time. Tap a workout to fix it.',
        },
        activityStats: {
            title: 'Last 30 days',
            text: 'How often, how long and how far — split by type.',
        },
        weightChart: {
            title: 'Weight trend',
            text: 'Dots are weigh-ins, the line is the 7-day average — day-to-day swings don’t hide the direction.',
            more: 'The big number above the chart is the trend, not your latest weigh-in.',
        },
        weightTarget: {
            title: 'Target weight',
            text: 'Set a goal and you’ll see how much is left and how fast you’re going.',
            more: 'We calculate your pace from the trend over the last 4 weeks.',
        },
        weightList: {
            title: 'Weigh-ins',
            text: 'All weigh-ins with the trend. Tap one to fix or delete it.',
        },
    },
    tour: {
        welcome: {
            title: 'Welcome to Fitness',
            text: 'Sleep, activity and weight in one place. In a minute I’ll show you where everything is — you can close this at any time.',
        },
        end: {
            title: 'That’s it',
            text: 'You can also add sleep and workouts in the day planner — they’ll show up here. The guide is always back under the “Help” button — that’s also where Getting started lives. And “What’s this?” next to each section explains it without the guide.',
        },
    },
};
